/* Benchmark page (/best-ai-detectors): leaderboard, heat matrix, length chart,
   spread chart and the score reader. Every figure is measured data from the
   August 2026 run on the GEDE corpus: 600 AI-involved texts and 150 human
   texts per detector. The page renders nothing without this file, so the
   markup carries only the shells.

   The FAQ accordion is not here -- the page uses the site's own .faq markup,
   which ios-cleaner.js already drives. */
(function () {
    'use strict';

    var host = document.querySelector('.bench');
    if (!host) return;

    /* fp = human texts wrongly flagged, out of the 150-text control set. */
    var DETECTORS = [
        {
            name: 'Clever AI Detector', ours: true, recall: 96.67, caught: 580, missed: 20, worst: 92.0, fp: 0, ci: [94.9, 97.8],
            type: { direct: 100.0, rewritten: 100.0, improved: 94.7, humanized: 92.0 },
            counts: { direct: 150, rewritten: 150, improved: 142, humanized: 138 },
            len: { u200: 91.7, w200: 93.8, w250: 98.1, w300: 97.6, w350: 96.4 }, color: '#0E7B54'
        },
        {
            name: 'Copyleaks', ours: false, recall: 95.00, caught: 570, missed: 30, worst: 86.7, fp: 0, ci: [93.0, 96.5],
            type: { direct: 100.0, rewritten: 100.0, improved: 86.7, humanized: 93.3 },
            counts: { direct: 150, rewritten: 150, improved: 130, humanized: 140 },
            len: { u200: 83.3, w200: 96.1, w250: 96.6, w300: 94.4, w350: 91.1 }, color: '#2E86C1'
        },
        {
            name: 'Originality Lite', ours: false, recall: 86.83, caught: 521, missed: 79, worst: 51.3, fp: 0, ci: [83.9, 89.3],
            type: { direct: 100.0, rewritten: 100.0, improved: 96.0, humanized: 51.3 },
            counts: { direct: 150, rewritten: 150, improved: 144, humanized: 77 },
            len: { u200: 45.8, w200: 67.4, w250: 92.9, w300: 97.6, w350: 96.4 }, color: '#8E44AD'
        },
        {
            name: 'Winston AI', ours: false, recall: 82.67, caught: 496, missed: 104, worst: 44.7, fp: 0, ci: [79.4, 85.5],
            type: { direct: 100.0, rewritten: 100.0, improved: 86.0, humanized: 44.7 },
            counts: { direct: 150, rewritten: 150, improved: 129, humanized: 67 },
            len: { u200: 41.7, w200: 65.1, w250: 89.5, w300: 96.8, w350: 76.8 }, color: '#D68910'
        },
        {
            name: 'Pangram', ours: false, recall: 67.50, caught: 405, missed: 195, worst: 18.0, fp: 0, ci: [63.7, 71.1],
            type: { direct: 100.0, rewritten: 88.0, improved: 18.0, humanized: 64.0 },
            counts: { direct: 150, rewritten: 132, improved: 27, humanized: 96 },
            len: { u200: 58.3, w200: 64.3, w250: 72.7, w300: 66.1, w350: 57.1 }, color: '#16A085'
        },
        {
            name: 'QuillBot', ours: false, recall: 64.17, caught: 385, missed: 215, worst: 22.0, fp: 0, ci: [60.3, 67.9],
            type: { direct: 100.0, rewritten: 96.7, improved: 38.0, humanized: 22.0 },
            counts: { direct: 150, rewritten: 145, improved: 57, humanized: 33 },
            len: { u200: 12.5, w200: 42.6, w250: 78.3, w300: 74.2, w350: 46.4 }, color: '#C0392B'
        },
        {
            name: 'GPTZero', ours: false, recall: 43.67, caught: 262, missed: 338, worst: 1.3, fp: 0, ci: [39.8, 47.7],
            type: { direct: 92.7, rewritten: 7.3, improved: 1.3, humanized: 73.3 },
            counts: { direct: 139, rewritten: 11, improved: 2, humanized: 110 },
            len: { u200: 41.7, w200: 62.0, w250: 46.1, w300: 35.5, w350: 8.9 }, color: '#C2379B'
        },
        {
            name: 'ZeroGPT', ours: false, recall: 18.83, caught: 113, missed: 487, worst: 0.0, fp: 0, ci: [15.9, 22.2],
            type: { direct: 70.0, rewritten: 4.7, improved: 0.0, humanized: 0.7 },
            counts: { direct: 105, rewritten: 7, improved: 0, humanized: 1 },
            len: { u200: 0.0, w200: 3.9, w250: 27.0, w300: 25.8, w350: 7.1 }, color: '#5D6D7E'
        }
    ];

    function esc(s) {
        return String(s).replace(/[&<>"]/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
        });
    }
    function cssVar(name) {
        return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    }

    /* ---------- leaderboard ---------- */
    var tbody = document.getElementById('benchTableBody');
    var sortKey = 'recall';
    var sortDir = -1;

    function barClass(v) { return v >= 90 ? '' : (v >= 75 ? 'mid' : 'low'); }

    function renderTable() {
        if (!tbody) return;
        var rows = DETECTORS.slice().sort(function (a, b) {
            if (sortKey === 'name') return sortDir * a.name.localeCompare(b.name);
            return sortDir * (a[sortKey] - b[sortKey]);
        });
        tbody.innerHTML = rows.map(function (d) {
            return '<tr class="' + (d.ours ? 'is-ours' : '') + '">' +
                '<th scope="row"><span class="det-name">' + esc(d.name) + '</span></th>' +
                '<td class="bar-cell"><div class="bar ' + barClass(d.recall) + '"><i style="width:' + d.recall + '%"></i></div><span class="bar-val">' + d.recall.toFixed(1) + '%</span></td>' +
                '<td class="bar-cell"><div class="bar ' + barClass(d.worst) + '"><i style="width:' + d.worst + '%"></i></div><span class="bar-val">' + d.worst.toFixed(1) + '%</span></td>' +
                '<td><span class="num">' + d.fp + ' / 150</span></td>' +
                '<td><span class="num">' + d.caught + ' / 600</span></td>' +
                '<td><span class="num dim">' + d.missed + '</span></td>' +
                '<td><span class="num dim">' + d.ci[0] + '–' + d.ci[1] + '%</span></td>' +
                '</tr>';
        }).join('');
    }

    Array.prototype.forEach.call(document.querySelectorAll('#benchTable th.sortable'), function (th) {
        th.addEventListener('click', function () {
            var k = th.dataset.key;
            if (sortKey === k) { sortDir *= -1; } else { sortKey = k; sortDir = (k === 'name') ? 1 : -1; }
            Array.prototype.forEach.call(document.querySelectorAll('#benchTable th.sortable'), function (o) {
                o.classList.remove('asc', 'desc');
            });
            th.classList.add(sortDir === 1 ? 'asc' : 'desc');
            renderTable();
        });
    });
    renderTable();

    /* ---------- heat matrix ---------- */
    var MX_COLS = ['direct', 'rewritten', 'improved', 'humanized'];
    var MX_NAMES = { direct: 'direct AI', rewritten: 'AI-rewritten', improved: 'AI-improved', humanized: 'humanized AI' };
    var mxBody = document.getElementById('benchMatrixBody');
    var mxMode = 'pct';

    function heat(v) {
        var stops = [[250, 241, 229], [244, 222, 193], [224, 233, 205], [186, 215, 189], [136, 196, 159], [94, 175, 133]];
        var t = Math.max(0, Math.min(1, v / 100)) * (stops.length - 1);
        var i = Math.min(stops.length - 2, Math.floor(t));
        var f = t - i;
        var c = stops[i].map(function (s, j) { return Math.round(s + (stops[i + 1][j] - s) * f); });
        return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')';
    }

    function renderMatrix() {
        if (!mxBody) return;
        mxBody.innerHTML = DETECTORS.map(function (d) {
            return '<tr><th scope="row">' + esc(d.name) + '</th>' + MX_COLS.map(function (c) {
                var pct = d.type[c];
                var label = mxMode === 'pct' ? pct.toFixed(1) + '%' : d.counts[c] + '/150';
                var title = d.name + ' on ' + MX_NAMES[c] + ': ' + pct.toFixed(1) + '% flagged (' + d.counts[c] + ' of 150)';
                return '<td><span class="cell" style="background:' + heat(pct) + '" title="' + esc(title) + '">' + label + '</span></td>';
            }).join('') + '</tr>';
        }).join('');
    }

    Array.prototype.forEach.call(document.querySelectorAll('#benchMatrixSeg button'), function (b) {
        b.addEventListener('click', function () {
            Array.prototype.forEach.call(document.querySelectorAll('#benchMatrixSeg button'), function (o) {
                o.classList.remove('active');
            });
            b.classList.add('active');
            mxMode = b.dataset.v;
            renderMatrix();
        });
    });
    renderMatrix();

    /* ---------- length chart ---------- */
    var LEN_KEYS = ['u200', 'w200', 'w250', 'w300', 'w350'];
    var LEN_LABELS = ['<200', '200–249', '250–299', '300–349', '350+'];
    var hidden = {};

    function renderChart() {
        var chartHost = document.getElementById('benchChart');
        if (!chartHost) return;
        var W = 860, H = 380, ml = 46, mr = 16, mt = 16, mb = 44;
        var iw = W - ml - mr, ih = H - mt - mb;
        var x = function (i) { return ml + (iw / (LEN_KEYS.length - 1)) * i; };
        var y = function (v) { return mt + ih - (v / 100) * ih; };
        var line = cssVar('--line'), muted = cssVar('--muted');
        var s = '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">';
        for (var v = 0; v <= 100; v += 25) {
            s += '<line x1="' + ml + '" y1="' + y(v) + '" x2="' + (W - mr) + '" y2="' + y(v) + '" stroke="' + line + '" stroke-width="1"' + (v ? ' stroke-dasharray="3 4"' : '') + '/>';
            s += '<text x="' + (ml - 10) + '" y="' + (y(v) + 4) + '" text-anchor="end" font-family="IBM Plex Mono, monospace" font-size="11" fill="' + muted + '">' + v + '%</text>';
        }
        LEN_LABELS.forEach(function (l, i) {
            s += '<text x="' + x(i) + '" y="' + (H - mb + 24) + '" text-anchor="middle" font-family="IBM Plex Mono, monospace" font-size="11.5" fill="' + muted + '">' + l + '</text>';
        });
        s += '<text x="' + (ml + iw / 2) + '" y="' + (H - 6) + '" text-anchor="middle" font-family="Hanken Grotesk, sans-serif" font-size="12" font-weight="700" fill="' + muted + '">Text length in words</text>';
        DETECTORS.forEach(function (d) {
            if (hidden[d.name]) return;
            var pts = LEN_KEYS.map(function (k, i) { return [x(i), y(d.len[k])]; });
            s += '<polyline points="' + pts.map(function (p) { return p.join(','); }).join(' ') + '" fill="none" stroke="' + d.color + '" stroke-width="' + (d.ours ? 3.2 : 2.2) + '" stroke-linejoin="round" stroke-linecap="round"' + (d.ours ? '' : ' opacity="0.92"') + '/>';
            pts.forEach(function (p, i) {
                s += '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="' + (d.ours ? 4.5 : 3.6) + '" fill="' + d.color + '"><title>' + esc(d.name) + ' at ' + LEN_LABELS[i] + ' words: ' + d.len[LEN_KEYS[i]].toFixed(1) + '%</title></circle>';
            });
        });
        s += '</svg>';
        chartHost.innerHTML = s;
    }

    function renderLegend() {
        var legend = document.getElementById('benchChartLegend');
        if (!legend) return;
        legend.innerHTML = DETECTORS.map(function (d) {
            return '<button type="button" class="lg-btn ' + (hidden[d.name] ? 'off' : '') + '" data-n="' + esc(d.name) + '" aria-pressed="' + (hidden[d.name] ? 'false' : 'true') + '">' +
                '<span class="dot" style="background:' + d.color + '"></span>' + esc(d.name) + '</button>';
        }).join('');
        Array.prototype.forEach.call(legend.querySelectorAll('.lg-btn'), function (b) {
            b.addEventListener('click', function () {
                var n = b.dataset.n;
                if (hidden[n]) { delete hidden[n]; } else { hidden[n] = true; }
                renderLegend();
                renderChart();
            });
        });
    }
    renderLegend();
    renderChart();

    /* ---------- how many of the eight caught each text ---------- */
    var SPREAD = [
        { label: 'Direct AI', row: [0, 0, 0, 0, 0, 0, 3, 50, 97] },
        { label: 'AI-rewritten', row: [0, 0, 0, 0, 1, 21, 110, 18, 0] },
        { label: 'Humanized AI', row: [0, 4, 15, 23, 42, 25, 22, 18, 1] },
        { label: 'AI-improved', row: [2, 4, 4, 21, 53, 53, 12, 1, 0] }
    ];

    function renderSpread() {
        var spreadHost = document.getElementById('benchSpread');
        if (!spreadHost) return;
        var W = 860, rowH = 68, headH = 26, footH = 32;
        var H = SPREAD.length * rowH + headH + footH;
        var ml = 124, mr = 12, iw = W - ml - mr;
        var band = iw / 9, bw = band * 0.46, maxH = 42;
        var cx = function (i) { return ml + band * (i + 0.5); };
        var muted = cssVar('--muted'), line = cssVar('--line'), ink = cssVar('--ink');
        var s = '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" style="width:100%;height:auto">';
        for (var i = 0; i <= 8; i++) {
            s += '<text x="' + cx(i) + '" y="14" text-anchor="middle" font-family="IBM Plex Mono, monospace" font-size="11" fill="' + muted + '">' + i + '</text>';
        }
        SPREAD.forEach(function (r, ri) {
            var base = headH + ri * rowH + rowH - 20;
            s += '<line x1="' + ml + '" y1="' + (base + 1) + '" x2="' + (W - mr) + '" y2="' + (base + 1) + '" stroke="' + line + '" stroke-width="1"/>';
            s += '<text x="' + (ml - 14) + '" y="' + (base - 2) + '" text-anchor="end" font-family="Hanken Grotesk, sans-serif" font-size="13" font-weight="700" fill="' + ink + '">' + r.label + '</text>';
            r.row.forEach(function (n, i) {
                var hgt = n ? Math.max(3, (n / 150) * maxH) : 2;
                var fill = n ? (i >= 5 ? '#0E7B54' : (i >= 3 ? '#8FA83E' : '#C25B00')) : line;
                s += '<rect x="' + (cx(i) - bw / 2) + '" y="' + (base - hgt) + '" width="' + bw + '" height="' + hgt + '" rx="3" fill="' + fill + '" opacity="' + (n ? 1 : .45) + '">' +
                    '<title>' + r.label + ': ' + n + ' of 150 texts caught by ' + i + ' detector' + (i === 1 ? '' : 's') + '</title></rect>';
                if (n >= 10) {
                    s += '<text x="' + cx(i) + '" y="' + (base + 14) + '" text-anchor="middle" font-family="IBM Plex Mono, monospace" font-size="10.5" fill="' + muted + '">' + n + '</text>';
                }
            });
        });
        s += '<text x="' + (ml + iw / 2) + '" y="' + (H - 6) + '" text-anchor="middle" font-family="Hanken Grotesk, sans-serif" font-size="12" font-weight="700" fill="' + muted + '">Number of detectors (out of 8) that caught the text</text>';
        s += '</svg>';
        spreadHost.innerHTML = s;
    }
    renderSpread();

    /* The two charts read their colours from the theme, so both are redrawn
       when the header toggle switches it. */
    var themeBtn = document.getElementById('dsThemeBtn');
    if (themeBtn) {
        themeBtn.addEventListener('click', function () {
            window.setTimeout(function () { renderChart(); renderSpread(); }, 0);
        });
    }

    /* ---------- score reader ---------- */
    var range = document.getElementById('benchScoreRange');
    var out = document.getElementById('benchScoreOut');
    var valEl = document.getElementById('benchScoreVal');
    var pin = document.getElementById('benchScorePin');

    function readScore(v) {
        if (v >= 95) return {
            t: 'Very likely machine-generated — but not proof of anything.',
            d: 'Scores this high were most common on raw, unedited AI output, where six of eight detectors were right 100% of the time. It is still a probability estimate: it cannot distinguish text a model wrote from text a model heavily edited, and it says nothing about who submitted it.'
        };
        if (v >= 75) return {
            t: 'Reads as AI-influenced. Worth a conversation, not a conclusion.',
            d: 'This band covers a lot of ground: fully generated text, machine-rewritten human drafts, and human writing that happens to be structurally regular. On this benchmark, detectors were most confident exactly where the text was a human draft that a model had edited — AI involvement, but not AI authorship.'
        };
        if (v >= 40) return {
            t: 'Genuinely uncertain. The tools disagree most here.',
            d: 'This is the band where the eight detectors agreed with each other only about half the time. A score in the middle does not mean "half AI" — it means the tool has not found enough signal to commit, and neither should you.'
        };
        if (v >= 15) return {
            t: 'Reads as mostly human, with the usual caveats.',
            d: 'A low score is also what most detectors returned for humanized AI and AI-improved drafts: ZeroGPT missed 99.3% of humanized text, QuillBot 78%. A low score is weak evidence of human authorship, not strong evidence.'
        };
        return {
            t: 'Reads as human — which is also what evasion tools are built to produce.',
            d: 'On the humanized-AI set, ZeroGPT returned a human verdict 99.3% of the time and QuillBot 78% of the time, on text that was entirely machine-generated. A near-zero score means the detector found nothing, which is not the same as there being nothing to find.'
        };
    }

    function updateScore() {
        if (!range || !out) return;
        var v = Number(range.value);
        if (valEl) valEl.textContent = v + '% AI';
        if (pin) pin.style.left = v + '%';
        var r = readScore(v);
        out.innerHTML = '<b>' + esc(r.t) + '</b>' + esc(r.d);
    }
    if (range) {
        range.addEventListener('input', updateScore);
        updateScore();
    }
})();
